import { connect } from 'react-redux';
import PollCard from './view';

const mapStateToProps = (state) => ({
  cardPanelActive: !!state.customPanels.find((panel) => panel.doc?.data?.cardDoc),
});

export default connect(mapStateToProps, null)(PollCard);
